module.exports = __webpack_public_path__ + "static/Album-3fd56b1dffbaa0340b7e1b778942b17b.pdf";